import { atom } from 'recoil';
// Used in hooks/useHandleUser
export default atom({
  key: 'userAtom',
  default: null
});